<template>
  <BasicCoupon
    class=""
    :originalCouponInfo="formattedCouponInfo"
    @btnClick="onGetCoupon"
    @couponClick="onCouponClick"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BasicCoupon } from '@tencent/wphk-act-base-components';
import { CouponInfo, CouponState } from '../../type';
import { formatCoupon } from './business';
import { to } from '@tencent/wphk-base-utils';
import { getCoupon } from '../coupon-item/business';
import { showLoading, hideLoading } from '@tencent/wphk-components-loading';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { i18n } from '../../i18n';
import { CustomException } from '@tencent/ppd-base-libs';
import { showToast } from '@tencent/wphk-components-toast';
import { goCouponDetail } from '../../business/coupon';

// 对基础coupon的再封装，格式化coupon数据，自定义部分样式
@Component({
  components: {
    BasicCoupon,
  },
})
export default class CashCoupon extends Vue {
  @Prop() couponInfo!: CouponInfo;
  @Prop({ default: true }) isShowButton!: boolean;
  /**
   * 是否展示领取成功 toast，默认展示
   */
  @Prop({ default: true }) isShowSuccToast!: boolean;
  // 是否点击了领取按钮
  isGetBtnClick = false;

  get formattedCouponInfo() {
    return formatCoupon(this.couponInfo, this.isShowButton);
  }

  /**
   * 领券
   */
  async getCoupon() {
    showLoading();
    const [error, res] = await to(getCoupon(this.couponInfo.merchantInfo!.spId, this.couponInfo.couponId));
    hideLoading();
    if (error) {
      showBusinessError(i18n('領取失敗，請稍候再試'));
      throw new CustomException(error, 'onGetCoupon', `${this.couponInfo}`);
    }
    if (this.isShowSuccToast) {
      showToast({
        title: i18n('領取成功'),
        duration: 1000,
      });
    }

    this.couponInfo.state = CouponState.Got;
    this.couponInfo.userScid = res?.userScid || '';
    return this.couponInfo;
  }

  /**
   * 去使用券
   */
  async useCoupon() {
    goCouponDetail(this.couponInfo.type, {
      userScid: this.couponInfo.userScid,
      adtag: 'discount-center',
    });
  }

  /**
   * 这里解决烦人的事件点击穿透问题
   */
  setGetBtnClickState() {
    this.isGetBtnClick = true;
    setTimeout(() => {
      this.isGetBtnClick = false;
    }, 300);
  }

  async onGetCoupon() {
    this.setGetBtnClickState();
    if (this.couponInfo.state === CouponState.Normal) {
      await this.getCoupon();
      this.$emit('onGotCoupon', this.couponInfo);
    } else if (this.couponInfo.state === CouponState.Got) {
      this.useCoupon();
    }
  }

  onCouponClick() {
    if (this.isGetBtnClick) {
      return;
    }
    this.$emit('couponClick', this.couponInfo);
  }
}
</script>

<style lang="less" scoped>
@import "../../less/main.less";
</style>
